<template>
    <div
        class="cart-banner"
        :class="classObject"
    >
        <ob1-liens
            v-if="backLink && !withSearchField"
            :text="backLink"
            with-arrow
            is-back
            href="#"
            @ob1-liens-click="backHandler"
        />
        <equipment-search-field
            v-if="withSearchField"
            class="me-2 w-100"
            :place-holder="searchFieldPlaceHolder"
            :search-results-url="searchResultsUrl"
            :search-results-query-additional-params="searchResultsQueryAdditionalParams"
            :algolia-api-key="algoliaApiKey"
            :algolia-app-id="algoliaAppId"
            :algolia-index-name="algoliaIndexName"
        />
        <span
            v-if="showCart"
            class="visually-hidden"
        >Lien vers le panier qui contient {{ numberOfItems }} articles</span>
        <a
            v-if="showCart"
            class="cart-icon no-decoration"
            :href="href"
            :class="aClass"
            :aria-disabled="!cartEnabled"
            @click="cartClickHandler"
        >
            <span class="icon" :class="classObjectIcon" aria-hidden="true" />
            <span v-show="numberOfItems !== 0" :class="numberCssClasses" v-html="numberOfItems" />
        </a>
    </div>
</template>

<script>
import EquipmentSearchField from "./fragments/EquipmentSearchField.vue";

export default {
    components: {EquipmentSearchField},
    props: {
        numberOfItems: {
            type: Number,
            default: 0
        },
        icon: {
            type: String,
            default: "icon-buy"
        },
        backLink: {
            type: String,
            default: ""
        },
        cartLink: {
            type: String,
            default: ""
        },
        // classes css pour l'icône
        iconCssClasses: {
            type: String,
            default: 'font-size-40'
        },
        // classes css pour le chiffre
        numberCssClasses: {
            type: String,
            default: 'cart-icon-number text-white bg-primary small'
        },
        // active/désactive le click sur le bouton panier
        cartEnabled: {
            type: Boolean,
            default: true
        },
        //lien retour
        backUrl: {
            type: String,
            required: false,
            default: undefined
        },
        // placeholder du bandeau de recherche
        searchFieldPlaceHolder: {
            type: String,
            required: false,
            default: ""
        },
        searchResultsUrl: {
            type: String,
            default: ""
        },
        searchResultsQueryAdditionalParams: {
            type: String,
            default: ""
        },
        showCart: {
            type: Boolean,
            default: true
        },
        algoliaAppId: {
            type: String,
            default: undefined
        },
        algoliaApiKey: {
            type: String,
            default: undefined
        },
        algoliaIndexName: {
            type: String,
            default: undefined
        }
    },
    computed: {
        classObjectIcon() {
            if (this.iconCssClasses != null) {
                return this.icon + " " + this.iconCssClasses;
            }
            return this.icon;
        },
        href() {
            return this.cartEnabled ? this.cartLink : null;
        },
        aClass() {
            return this.cartEnabled ? null : "disabled";
        },
        classObject() {
            return {
                'justify-content-end align-items-center': this.withSearchField || this.backLink === "",
                'justify-content-between align-items-center': this.backLink !== ""
            }
        },
        withSearchField() {
            return this.algoliaApiKey && this.algoliaAppId && this.algoliaIndexName
        }
    },
    methods: {
        cartClickHandler() {
            if (this.cartEnabled) {
                this.$emit('cart-click');
            }
        },
        backHandler() {
            event.preventDefault(); // nécessaire pour un bon fonctionnement sur Safari
            if (this.backUrl) {
                window.location.href = this.backUrl;
            } else {
                window.history.back();
            }
        }
    }
}
</script>

<style scoped lang="scss">
@import 'ob1_common';
.cart-banner {
    grid-column: 1/-1;
    display: flex;
    .cart-icon {
        position: relative;
}
    .cart-icon-number {
        width: px-to-rem(16);
        height: px-to-rem(16);
        padding: 0 px-to-rem(5) px-to-rem(1) px-to-rem(5);
        border-radius: px-to-rem(10);
        right: px-to-rem(-5);
        top: px-to-rem(4);
        font-weight: bold;
        text-align: center;
        position: absolute;
        font-size: px-to-rem(12);
}
    // Pour le mini panier desactivé
    a.disabled {
        cursor: not-allowed;
        color: #CCCCCC;
}
    a:hover.disabled {
        color: #CCCCCC;
}
}
</style>
